export const opacity = {
  0: '1',
  1: '0.8',
  2: '0.6',
  3: '0.4',
  4: '0.2',
};

export const rows = [1, 2, 3, 4, 5];
